import React, { useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { ExportContext } from '@nile/components';
import SharedReport from '@nile/reports/src/modules/reports/components/pages/SharedReport';
import EditReport from '@nile/reports/src/modules/reports/components/pages/EditReport';
import {
  PDF_WIDTH,
  PDF_HEIGHT,
  GRAPH_WIDTH,
  GRAPH_HEIGHT,
  PDF_GUTTER
} from '@nile/reports/src/modules/charts/constants';
import envConfig from '@nile/home/src/Config/env';

const ExportsPage = (props) => {
  const { match } = props;
  const [isRendered, setIsRendered] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reportName, setReportName] = useState('');
  const [reportData, setReportData] = useState([]);
  const [brandingLogo, setBrandingLogo] = useState({});
  const element = document.querySelector('#exportPage');
  const child = document.querySelectorAll('.chart-card');
  const brandLogo = document.querySelector('.msp-branding');
  const childArr = [...child];

  const jspdfScript = () => {
    function addScript(url) {
      const script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      document.head.appendChild(script);
    }
    addScript('https://html2canvas.hertzen.com/dist/html2canvas.min.js');
    addScript('https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js');
  };
  useEffect(() => {
    // jspdfScript();
  }, []);
  /** Get Data need to print in PDF */
  const getHtml = async () => {
    setTimeout(() => {
      const logo = renderImage(brandLogo);
      logo.then((res) =>
        setBrandingLogo(() => ({
          width: res.imageCanvas.width,
          height: res.imageCanvas.height,
          type: 'CUSTOM',
          data: res.image
        }))
      );
    }, 1000);
    childArr.map((el) => {
      setTimeout(() => {
        const resultImage = renderImage(el);
        resultImage.then((res) =>
          setReportData((prevState) => [
            ...prevState,
            {
              width: res.imageCanvas.width,
              height: res.imageCanvas.height,
              type: res.imageCanvas.type,
              data: res.image
            }
          ])
        );
      }, 500);
    });
  };

  /** Convert HTML to canvas */
  const renderImage = async (el) => {
    let image = '';
    let imageCanvas = {
      width: 0,
      height: 0,
      type: ''
    };
    await html2canvas(el, {
      useCORS: true,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: element.offsetWidth,
      windowHeight: element.scrollHeight
    }).then((canvas) => {
      const childCanva = el.querySelector('.chart-card canvas');
      canvas.getContext('2d');

      if (childCanva) {
        image = childCanva.toDataURL('image/png');
        imageCanvas.width = GRAPH_WIDTH;
        imageCanvas.height = GRAPH_HEIGHT;
        imageCanvas.type = 'CHART';
      } else {
        image = canvas.toDataURL('image/png');
        imageCanvas.width = canvas.width;
        imageCanvas.height = canvas.height;
        imageCanvas.type = 'CUSTOM';
      }
    });
    return { image, imageCanvas };
  };

  const addHeader = (pdf) => {
    if (brandingLogo) {
      pdf.addImage(
        brandingLogo.data,
        'png',
        PDF_GUTTER.left_margin,
        PDF_GUTTER.header_top,
        brandingLogo.width,
        brandingLogo.height
      );
    }
  };

  /** Insert canvas image to the pdf */
  const generatePDF = async () => {
    let PDF_Height = PDF_HEIGHT;
    let xHeight = PDF_GUTTER.header_top + PDF_GUTTER.header_height;
    const pdf = new jsPDF('p', 'px', [PDF_WIDTH, PDF_HEIGHT]);
    addHeader(pdf);
    await reportData.map((canva) => {
      /** Calculate available height and append image accordingly */
      if (PDF_Height - PDF_GUTTER.top_margin * 2 < canva.height) {
        PDF_Height = PDF_HEIGHT;
        xHeight = PDF_GUTTER.header_top;
        pdf.addPage([PDF_WIDTH, PDF_HEIGHT]);
        /**  To add header on each page
          addHeader(pdf);
        */
      }

      pdf.addImage(
        canva.data,
        'png',
        PDF_GUTTER.left_margin,
        xHeight,
        canva.type === 'CHART'
          ? canva.width
          : PDF_WIDTH - PDF_GUTTER.left_margin * 2,
        canva.height - 10
      );

      /** Recalculating pdf available height */
      PDF_Height -= canva.height + PDF_GUTTER.top_margin;
      xHeight += canva.height + PDF_GUTTER.top_margin;
    });

    pdf.save(reportName);
    setLoading(false);
    setReportData([]);
  };

  // useEffect(() => {
  //   if (isRendered) {
  //     setTimeout(() => {
  //       if (loading) getHtml();
  //     }, 2000);
  //   }
  // }, [isRendered, loading]);

  // useEffect(() => {
  //   if (
  //     reportData.length !== 0 &&
  //     child.length !== 0 &&
  //     reportData.length === child.length &&
  //     Object.keys(brandingLogo).length
  //   ) {
  //     generatePDF();
  //   }
  // }, [reportData, brandingLogo]);

  const getExportedContent = () => {
    const { pagename, id } = match.params;
    switch (pagename) {
      case 'sharedreport':
        return <SharedReport sharedReportId={id} isExported />;
      case 'report':
        return <EditReport reportId={id} isExported />;
      default:
        return <Redirect to="/pagenotfound" />;
    }
  };

  useEffect(() => {
    if (isRendered) {
      setTimeout(() => {
        try {
          // Print for Safari browser
          document.execCommand('print', false, null);
        } catch {
          window.print();
        }
      }, 2000);
    }
  }, [isRendered]);

  return (
    <ExportContext.Provider
      value={{
        isRendered,
        setIsRendered,
        loading,
        setLoading,
        setReportName
      }}
    >
      <div id="exportPage" className="full-height">
        {getExportedContent()}
      </div>
    </ExportContext.Provider>
  );
};

export default withRouter(ExportsPage);
